@if (modelStrategies && modelStrategies.length) {
  <div class="model-portfolios">
    @if (modelStrategiesForView.strategies.length) {
      <div class="section-heading" data-cy="model-strategies-header">
        {{ 'thematicStrategies.strategiesHeading' | translate }}
      </div>
      <div data-cy="model-strategies">
        <libero-model-strategy-swiper
          [strategies]="modelStrategiesForView.strategies"
        ></libero-model-strategy-swiper>
      </div>
    }
    @if (modelStrategiesForView.portfolios.length) {
      <div class="section-heading" data-cy="model-strategies-portfolios-header">
        {{ 'thematicStrategies.portfoliosHeading' | translate }}
      </div>
      <div data-cy="portfolios-model-strategies">
        <libero-model-strategy-swiper
          [strategies]="modelStrategiesForView.portfolios"
        ></libero-model-strategy-swiper>
      </div>
    }
    @if (modelStrategiesForView.oks.length) {
      <div class="section-heading" data-cy="model-strategies-oks-header">
        {{ 'thematicStrategies.oksHeading' | translate }}
      </div>
      <div data-cy="oks-model-strategies">
        <libero-model-strategy-swiper
          [strategies]="modelStrategiesForView.oks"
        ></libero-model-strategy-swiper>
      </div>
    }
  </div>
} @else if (!loggedUser.canReadEnglish) {
  <div>
    <div class="no-data-container">
      {{ 'global.error.englishLimitedModels' | translate }}
    </div>
  </div>
} @else {
  <div class="no-data-container">
    {{ 'global.error.noData' | translate }}
  </div>
}
